import { useEffect } from 'react'
import { KTIcon } from '../../../../_metronic/helpers'
import { useNavigate } from 'react-router-dom'

const SharedContactModal = ({
  shared = [],
  onClose
}) => {
const navigate = useNavigate()

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className={`modal-dialog modal-dialog-centered mw-550px`}>
          <div className='modal-content'>
            <div className='modal-header py-4'>
              <h2 className='fw-bolder'>Shared Contacts</h2>
              <div
                className='btn btn-icon btn-sm btn-active-icon-primary'
                data-kt-users-modal-action='close'
                onClick={onClose}
                style={{ cursor: 'pointer' }}
              >
                <KTIcon iconName='cross' className='fs-1' />
              </div>
            </div>
            <div className={`modal-body scroll-y mx-2 mx-xl-2 my-2`}>
              <>
              <div className='table-responsive px-0 mh-300px min-h-auto'>
                <table
                  id='kt_table_users'
                  className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
                >
                  <thead>
                    <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
                      <th>Name</th>
                      <th className='text-end px-4'>Email Address</th>
                    </tr>
                  </thead>
                  <tbody className='text-dark-600 fw-bold'>
                    {shared && shared.length > 0 ? (
                    shared.map((row, index) => (
                    <tr key={index}>
                      <td className={`${row?.uid ? 'pointer hover text-hover-primary`' : 'default'}`}
                        onClick={() => {
                          if (row?.uid) {
                           navigate(`/users/${row?.uid}`)
                          }
                        }}
                      >{row.name}</td>
                      <td className='text-end px-4'>{row.email}</td>
                    </tr>
                    ))
                    )
                    :
                    <tr>
                      <td colSpan={2} className='text-center'>No Shared Contacts</td>
                    </tr>
                  }
                  </tbody>
                </table>
                </div>
                <div className="text-center pt-10">
                  <button
                    type="reset"
                    onClick={onClose}
                    className="btn btn-light mx-3"
                    data-kt-users-modal-action="cancel"
                  >
                    Close
                  </button>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export { SharedContactModal }
